import React, {useState} from 'react'
import './paginator.scss'

const Paginator = props => {
  const { totalPageButtons, totalPages, fetchPage } = props
  const [actualPage, setActualPage] = useState(1);

  const renderButtons = () => {
    let buttons = []

    if (actualPage > 1) {
      buttons.push(
        <div className='f-button-arrow' key={'previus'} onClick={() => {setActualPage(actualPage - 1); fetchPage(actualPage-1)}}><span className="icon-left"></span></div>
      )
    }

    let initialNumberPage = 0;
    let totalButtons = initialNumberPage + totalPageButtons;
    if (actualPage > totalPageButtons) {
      initialNumberPage = (actualPage - totalPageButtons);
      totalButtons = initialNumberPage + totalPageButtons;
    }
    if (totalButtons > totalPages) {
      totalButtons = totalPages;
    }
    for (let i = initialNumberPage; i < totalButtons; i++) {
      let classess = "f-buttons-default";
      if (i === (actualPage - 1)) {
        classess += " f-buttons-selected";
      }
      const page = i + 1;
      buttons.push(
        <div key={i} className={classess} onClick={() => {setActualPage(page); fetchPage(page)}} >{page}</div>
      )
    }

    if (actualPage < totalPages) {
      buttons.push(
        <div className='f-button-arrow' key={'next'} onClick={() =>{ setActualPage(actualPage + 1); fetchPage(actualPage+1)}}><span className="icon-right"></span></div>
      )
    }

    return buttons;
  }

  return (
    <div className="f-buttons-page-container">
      {renderButtons()}
    </div>
  )
}

export default Paginator
